module.exports = "/dist/img/mapwithpin.1203fcdcfbd4e67cbc9dc2891d2f7772.svg";